import { RecordDataSource } from "../../../records/grids";

import { IGridSettings } from "../../../records/grids/settings/gridSettingsService";

import { IQuery } from "../../../records/server/query";

import { ColDef } from "../../../records/grids/columns/colDef";
import { GridArgs } from "../../../records/grids/gridArgs";
import { IPromise } from "angular";

export class UserGridComponentController {
  static $inject = [];

  /* bindings */
  readonly gridDataSource!: RecordDataSource;
  readonly gridSettings!: IGridSettings;
  readonly columns!: ColDef[];
  readonly defaultSort!: string;
  readonly defaultQuery!: IQuery;
  readonly nameSingular!: string;
  readonly namePlural!: string;
  readonly showAddButton!: boolean;
  readonly showAddButtonPermission!: string;
  readonly onAddNew!: () => IPromise<any>;
  readonly onItemCommand!: (args: GridArgs) => IPromise<any>;
  /* end bindings */

  public showActiveOnly: boolean = true;

  constructor() {}

  public toggleActiveOnly(showActiveOnly: boolean): void {
    const defaultQuery = this.defaultQuery;

    if (showActiveOnly) {
      defaultQuery.Locked = false;
    } else {
      delete defaultQuery.Locked;
    }
  }
}
